import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { logout, selectClientAuth } from "../../auth-client/slice/clientAuth";

const isTokenValid = () => {
  const expiryTime = localStorage.getItem("client_token_expiry");
  if (!expiryTime) return false;

  const currentTime = new Date().getTime();
  return currentTime < parseInt(expiryTime);
};

const unprotectedPaths = ["/panel/info", "/panel/verify", "/panel", "/client/chat/provider"];

const ClientMiddleware = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const isClientLoggedIn = useSelector(selectClientAuth);
  const isVerified = useSelector((state) => state.clientInfo.isClientVerified);
  // console.log("isClientLoggedIn", isClientLoggedIn);

  const tokenValid = isTokenValid();

  const shouldRedirect = !isClientLoggedIn || !tokenValid;
  const isUnverifiedAccessingProtectedPage =
  !isVerified && !unprotectedPaths.some(path => location.pathname.startsWith(path));

  if (shouldRedirect) {
    dispatch(logout());
    localStorage.removeItem("client_access_token");
    localStorage.removeItem("client_token_expiry");
    localStorage.removeItem("user_id");

    return <Navigate to="/signin" replace />;
  }

  if (isUnverifiedAccessingProtectedPage) {
    return <Navigate to="/panel/verify" replace />;
  }

  return children;
};

ClientMiddleware.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ClientMiddleware;
